import getRandomColor from "../assets/utils/getRandomColor.js";
import { configIconsPolyline } from "../assets/utils/configIconsPolyline.js";
// const aElements = [
//   {
//     id: 1,
//     name: "Banco de condensadores",
//     src: "https://s3thiago.s3.amazonaws.com/BANCO+DE+CONDENSADORES.png",

//   },
//   {
//     id: 2,
//     name: "Fusibles",
//     src: "https://s3thiago.s3.amazonaws.com/FUSIBLES.png",
//   },
//   {
//     id: 3,
//     name: "Centros de transformación",
//     src: "https://s3thiago.s3.amazonaws.com/CENTRO+DE+TRANSFORMACION.png",
//   },
//   {
//     id: 4,
//     name: "Disyuntores",
//     src: "https://s3thiago.s3.amazonaws.com/INTERRUPTOR+AUTOMATICO.png",
//   },
//   {
//     id: 5,
//     name: "Interruptores",
//     src: "https://s3thiago.s3.amazonaws.com/INTERRUPTOR.png",
//   },
//   {
//     id: 6,
//     name: "Pararayos",
//     src: "https://s3thiago.s3.amazonaws.com/PARARRAYO.png",
//   },
//   {
//     id: 7,
//     name: "Puentes",
//     src: "https://s3thiago.s3.amazonaws.com/PUENTE.png",
//   },
//   {
//     id: 8,
//     name: "Regulador",
//     src: "https://s3thiago.s3.amazonaws.com/REGULADOR+DE+LINEA.png",
//   },
//   {
//     id: 9,
//     name: "Seccionador",
//     src: "https://s3thiago.s3.amazonaws.com/SECCIONADOR.png",
//   },
// ];

export default {
  namespaced: true,
  state: {
    // Elementos de red
    /**
     * Banco de condensadores
     * Fusibles
     * Centros de transformación
     * Disyuntores
     * interruptores
     * pararayo
     * puente
     * regultador
     * Seccionador
     */
    circuits: [],
    nkeyMap: 0,
    moveMap: {
      center: {},
      zoom: 18,
    },
    center: {
      lat: 10.9784174,
      lng: -74.8144132,
    },
    oSeeElement: {
      isSearch: false,
      codigo_elemento: null,
      type: null,
    },
    // bdiv10_bdi_banco: [],
    // bdiv10_bdi_fusib: [],
    // bdiv10_sgd_ct: [],
    // aFilterbdiv10_sgd_ct: [],
    // bdiv10_sgd_disyun: [],
    // bdiv10_sgd_interr: [],
    // bdiv10_sgd_pararrayo: [],
    // bdiv10_sgd_puente: [],
    // bdiv10_sgd_regulador: [],
    // bdiv10_sgd_secci: [],
  },
  getters: {
    getCircuits(state) {
      return state.circuits;
    },
    getNKeyMap(state) {
      return state.nkeyMap;
    },
    getCenter(state) {
      return state.center;
    },
    getSeeElement(state) {
      return state.oSeeElement;
    },
  },
  mutations: {
    SET_CIRCUIT(state, data) {
      state.circuits = data;
    },
    ADD_CIRCUIT(state, data) {
      state.circuits = [...state.circuits, data];
    },
    REMOVE_CIRCUIT(state, data) {
      state.circuits = state.circuits.filter(
        (circuit) => circuit.codigo_circuito !== data.codigo_circuito
      );
    },
    ON_CLEAR_CIRCUIT_MAP(state) {
      state.circuits = [];
      state.nkeyMap += 1;
    },
    SET_CENTER(state, data) {
      state.center = data;
    },
    SET_SEE_ELEMENT(state, data) {
      state.oSeeElement = data;
    },
  },
  actions: {
    onValidateUbication({ state }, value) {
      if (state.circuits);
      if (!(typeof value === "string")) return false;
      return !isNaN(parseFloat(value.replace(",", ".")));
    },
    __trasnformPolyline({ dispatch }, data) {
      let aPolyline = [];
      const strokeColor = getRandomColor();
      data?.geojson?.forEach(({ posiciones, estado_real_elemento }) => {
        //   const afavor = dispatch("onValidateUbication", latitud_1);
        // Validamos que todas las latitudes y longitudes sean válidas
        let options = {
          path: [],
          geodesic: true,
          // Si el estado es !== de 1 es desenergizado white
          strokeColor: estado_real_elemento === 1 ? strokeColor : "#FFF",
          // strokeColor: index <122 == 0 ? '#FF5733' : "#00A86B",
          strokeOpacity: 1,
          strokeWeight: 3.2,
        };

        const paths = posiciones.map((position) => {
          if (
            dispatch("onValidateUbication", position.latitud) &&
            dispatch("onValidateUbication", position.longitud)
          ) {
            return {
              lat: parseFloat(position.latitud.replace(",", ".")),
              lng: parseFloat(position.longitud.replace(",", ".")),
            };
          }
        });

        options.path = paths;
        aPolyline.push(options);
      });
      return aPolyline;
    },
    __transformElement({ dispatch }, values) {
      let aData = [];
      values?.forEach((element) => {
        const configIcon = configIconsPolyline(
          element?.details.tipo_elemento,
          element.estado_real_elemento !== 1
        );

        const oConfigElement = {
          position: {},
          // label: element?.matricula || "--No information--",
          // title: element?.matricula || "--No information--",
          options: {
            path: [],
            geodesic: true,
            // Si el estado es !== de 1 es desenergizado white
            strokeColor: configIcon ? configIcon.strokeColor : "#F00",
            // strokeColor: index <122 == 0 ? '#FF5733' : "#00A86B",
            strokeOpacity: 1,
            strokeWeight: 3,
            clickable: true,
            icons: configIcon
              ? [
                  {
                    icon: {
                      ...configIcon,
                    },
                    offset: "50%",
                  },
                ]
              : [],
          },
          icon: element?.icon_path,
          details: element?.details,
          optimized: true,
          animation: 4,
        };
        const paths = element.posiciones.map((position) => {
          if (
            dispatch("onValidateUbication", position.latitud) &&
            dispatch("onValidateUbication", position.longitud)
          ) {
            return {
              lat: parseFloat(position.latitud?.replace(",", ".")),
              lng: parseFloat(position.longitud?.replace(",", ".")),
            }
          }
        });
        oConfigElement.position = paths[0];
        oConfigElement.options.path = paths;
        aData.push(oConfigElement);
      });
      return aData;
    },
    async getAllDataCircuit({ dispatch }, { data, codigo_circuito }) {
      const [
        bdiv10_bdi_banco,
        bdiv10_bdi_fusib,
        bdiv10_sgd_ct,
        bdiv10_sgd_disyun,
        bdiv10_sgd_interr,
        bdiv10_sgd_pararrayo,
        bdiv10_sgd_puente,
        bdiv10_sgd_regulador,
        bdiv10_sgd_secci,
        arrResPolyline,
      ] = await Promise.all([
        dispatch("__transformElement", data?.bdiv10_bdi_banco),
        dispatch("__transformElement", data?.bdiv10_bdi_fusib),
        dispatch("__transformElement", data?.bdiv10_sgd_ct),
        dispatch("__transformElement", data?.bdiv10_sgd_disyun),
        dispatch("__transformElement", data?.bdiv10_sgd_interr),
        dispatch("__transformElement", data?.bdiv10_sgd_pararrayo),
        dispatch("__transformElement", data?.bdiv10_sgd_puente),
        dispatch("__transformElement", data?.bdiv10_sgd_regulador),
        dispatch("__transformElement", data.bdiv10_sgd_secci),
        dispatch("__trasnformPolyline", data),
      ]);

      return {
        bdiv10_bdi_banco,
        bdiv10_bdi_fusib,
        bdiv10_sgd_ct,
        bdiv10_sgd_disyun,
        bdiv10_sgd_interr,
        bdiv10_sgd_pararrayo,
        bdiv10_sgd_puente,
        bdiv10_sgd_regulador,
        bdiv10_sgd_secci,
        arrResPolyline,
        codigo_circuito,
      };
    },
    setCircuit({ commit, dispatch }, { data, codigo_circuito }) {
      const allData = dispatch("getAllDataCircuit", { data, codigo_circuito });
      commit("SET_CIRCUIT", [allData]);
    },
    removeCircuit({ commit }, { codigo_circuito }) {
      commit("REMOVE_CIRCUIT", { codigo_circuito });
    },
    async addNewCircuit({ commit, dispatch }, { data, codigo_circuito }) {
      const circuit = await dispatch("getAllDataCircuit", {
        data,
        codigo_circuito,
      });
      commit("ADD_CIRCUIT", circuit);
    },
    onClearCircuitMap({ commit }) {
      commit("ON_CLEAR_CIRCUIT_MAP");
    },
    onUpdateCenterNetwork({ commit }, data) {
      commit("SET_CENTER", data);
    },
    onUpdateSeeElement({ commit }, data) {
      commit("SET_SEE_ELEMENT", data);
    },
  },
};
